export const TIMER_REPEAT_DRIVER_EMAIL = 'timer_repeat_driver_email'
export const TIMER_REPEAT_DRIVER_EMAIL_TIME = 60000
